import { render } from "./ManageOrders.vue?vue&type=template&id=3a273a37"
import script from "./ManageOrders.vue?vue&type=script&lang=js"
export * from "./ManageOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__